"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationRule = void 0;
/**
 * Notification rules allow full control over notifications generated by the various Datadog security products.
 * They allow users to define the conditions under which a notification should be generated (based on rule severities,
 * rule types, rule tags, and so on), and the targets to notify.
 * A notification rule is composed of a rule ID, a rule type, and the rule attributes. All fields are required.
 */
class NotificationRule {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return NotificationRule.attributeTypeMap;
    }
}
exports.NotificationRule = NotificationRule;
/**
 * @ignore
 */
NotificationRule.attributeTypeMap = {
    attributes: {
        baseName: "attributes",
        type: "NotificationRuleAttributes",
        required: true,
    },
    id: {
        baseName: "id",
        type: "string",
        required: true,
    },
    type: {
        baseName: "type",
        type: "NotificationRulesType",
        required: true,
    },
    additionalProperties: {
        baseName: "additionalProperties",
        type: "any",
    },
};
//# sourceMappingURL=NotificationRule.js.map